import React, { useState, useEffect } from 'react';
import styles from './PublicSiteHeader.module.css';

const SECTION_LABELS: Record<string, string> = {
  about: 'Over',
  gebiedsanalyse: 'Gebied',
  facts: 'Cijfers',
  timeline: 'Tijdlijn',
  media: 'Media',
  participation: 'Participatie',
  faq: 'FAQ',
  contact: 'Contact',
  newsletter: 'Nieuwsbrief',
};

interface PublicSiteHeaderProps {
  projectName: string;
  sections: string[];
}

export const PublicSiteHeader: React.FC<PublicSiteHeaderProps> = ({ projectName, sections }) => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
    setMenuOpen(false);
  };

  const navSections = sections.filter(s => s !== 'hero' && s !== 'newsletter');

  return (
    <header className={`${styles.header} ${scrolled ? styles.scrolled : ''}`}>
      <div className={styles.container}>
        <span className={styles.logo} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          {projectName}
        </span>

        <nav className={`${styles.nav} ${menuOpen ? styles.navOpen : ''}`}>
          {navSections.map(id => (
            <button
              key={id}
              className={styles.navLink}
              onClick={() => scrollToSection(id)}
            >
              {SECTION_LABELS[id] || id}
            </button>
          ))}
        </nav>

        <button
          className={`${styles.hamburger} ${menuOpen ? styles.hamburgerOpen : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </header>
  );
};
